// extracted by mini-css-extract-plugin
module.exports = {"welcomeText":"WelcomeText_welcomeText__2GObc"};